import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  ArrowRight,
  BarChart3,
  BellRing,
  Building2,
  CreditCard,
  FileText,
  ShieldCheck,
} from 'lucide-react';

import './VakraControlCenterHome.css';

const VakraControlCenterHome = () => {
  const navigate = useNavigate();

  const handleLogin = () => {
    navigate('/control-center/login');
  };

  return (
    <div className="vcc-home">
      <div className="vcc-background-shape vcc-shape-one" />
      <div className="vcc-background-shape vcc-shape-two" />

      <header className="vcc-header">
        <button
          type="button"
          className="vcc-brand"
          onClick={() => navigate('/control-center')}
          aria-label="VAKRA Control Center home"
        >
          <div className="vcc-logo">V</div>

          <div className="vcc-brand-text">
            <span className="vcc-brand-name">VAKRA</span>
            <span className="vcc-brand-subtitle">CONTROL CENTER</span>
          </div>
        </button>

        <button
          type="button"
          className="vcc-header-login"
          onClick={handleLogin}
        >
          Admin Login
          <ArrowRight size={18} />
        </button>
      </header>

      <main className="vcc-main">
        <section className="vcc-hero">
          <div className="vcc-status">
            <span className="vcc-status-dot" />
            Central Management Platform
          </div>

          <h1>
            Manage the complete
            <span> VAKRA ecosystem</span>
            <br />
            from one place
          </h1>

          <p className="vcc-description">
            Vendors, subscriptions, payments, invoices, smart offer campaigns,
            notifications and performance reports — everything securely
            managed through one central control center.
          </p>

          <div className="vcc-actions">
            <button
              type="button"
              className="vcc-primary-button"
              onClick={handleLogin}
            >
              Login to Control Center
              <ArrowRight size={20} />
            </button>

            <div className="vcc-security-note">
              <ShieldCheck size={20} />
              Secure admin access
            </div>
          </div>
        </section>

        <section className="vcc-preview-card">
          <div className="vcc-preview-header">
            <div>
              <p>VAKRA Overview</p>
              <span>Central operations monitoring</span>
            </div>

            <div className="vcc-live-badge">
              <span />
              LIVE
            </div>
          </div>

          <div className="vcc-stat-grid">
            <div className="vcc-stat-card">
              <div className="vcc-stat-icon">
                <Building2 size={22} />
              </div>
              <span>Total Vendors</span>
              <strong>—</strong>
              <small>Available after login</small>
            </div>

            <div className="vcc-stat-card">
              <div className="vcc-stat-icon">
                <CreditCard size={22} />
              </div>
              <span>Subscriptions</span>
              <strong>—</strong>
              <small>Active and expiring plans</small>
            </div>

            <div className="vcc-stat-card">
              <div className="vcc-stat-icon">
                <BellRing size={22} />
              </div>
              <span>Smart Campaigns</span>
              <strong>—</strong>
              <small>Offer digest campaigns</small>
            </div>

            <div className="vcc-stat-card">
              <div className="vcc-stat-icon">
                <BarChart3 size={22} />
              </div>
              <span>Analytics</span>
              <strong>—</strong>
              <small>Clicks, orders and revenue</small>
            </div>
          </div>

          <div className="vcc-preview-footer">
            <div className="vcc-footer-item">
              <FileText size={18} />
              Invoice Management
            </div>

            <div className="vcc-footer-divider" />

            <div className="vcc-footer-item">
              <BellRing size={18} />
              Smart Notification Rotation
            </div>
          </div>
        </section>
      </main>

      <section className="vcc-features">
        <article className="vcc-feature">
          <div className="vcc-feature-number">01</div>
          <div>
            <h3>Vendor Management</h3>
            <p>
              Manage vendor profiles, account status, business type and
              platform access.
            </p>
          </div>
        </article>

        <article className="vcc-feature">
          <div className="vcc-feature-number">02</div>
          <div>
            <h3>Billing and Subscription</h3>
            <p>
              Track payments, plan validity, invoices, renewals and upcoming
              expiries.
            </p>
          </div>
        </article>

        <article className="vcc-feature">
          <div className="vcc-feature-number">03</div>
          <div>
            <h3>Smart Offer Campaigns</h3>
            <p>
              Monitor relevant customer matching, campaign rotation and vendor
              exposure.
            </p>
          </div>
        </article>
      </section>

      <footer className="vcc-footer">
        <p>© {new Date().getFullYear()} VAKRA. All rights reserved.</p>

        <div>
          <span>VAKRA Vendor</span>
          <span>VAKRA Food Radar</span>
          <span>VAKRA Control Center</span>
        </div>
      </footer>
    </div>
  );
};

export default VakraControlCenterHome;
